import type { ReactNode } from "react";

import { cn } from "./lib/cn";

export interface CardProps {
  title?: string;
  /** Başlığın altındaki tek satırlık açıklama; kartın ne gösterdiğini söyler. */
  description?: string;
  actions?: ReactNode;
  children: ReactNode;
  /** `compact` = 20px iç boşluk (mockup mini-kartları); varsayılan 24px (§5). */
  padding?: "default" | "compact";
  className?: string;
}

/**
 * Kart — onaylı görsel dilin taşıyıcısı.
 *
 * ⚠ UI Tur 2 §1/§5: kartlar GÖLGESİZ + 1px `border-default`. `shadow-sm` yalnız hover'da
 * satır/karta uygulanır (sayfa katmanında); Card'ın kendisi statik durumda gölge taşımaz —
 * tasarımda kartlar zeminden gölgeyle değil, kenarlıkla ayrışıyor.
 *
 * ⚠ Başlık şeridini AYIRAN ÇİZGİ YOK. Tasarımda kart tek parça beyaz bir yüzey; başlığı
 * içerikten ayıran şey çizgi değil boşluk. Çizgi kaldığında iç içe kartlarda (bölüm
 * kartının içindeki tablo kartı) üç ayrı yatay çizgi üst üste biniyordu.
 */
export function Card({
  title,
  description,
  actions,
  children,
  padding = "default",
  className,
}: CardProps) {
  const bodyPadding = padding === "compact" ? "p-5" : "p-6";
  const headerPadding = padding === "compact" ? "px-5 pt-5 pb-1" : "px-6 pt-6 pb-1";
  return (
    <section className={cn("rounded-lg border border-border-default bg-surface", className)}>
      {title || actions ? (
        <header className={cn("flex flex-wrap items-start justify-between gap-3", headerPadding)}>
          {title ? (
            /**
             * ⚠ `<hgroup>`, `<div>` DEĞİL. Başlık + açıklama ikilisi zaten `hgroup`'un
             * tanımı; ama seçim aynı zamanda ÖLÇÜLMÜŞ bir kırılmayı önlüyor: sözleşme
             * belge ekranının bir testi `getByText(...).closest("section, div")` ile
             * karttan yukarı çıkıyor. Araya bir `div` girdiğinde o arama kartın gövdesine
             * değil, yalnız başlığı saran kaba düşüyor ve kartın metni "kayıp" görünüyor.
             */
            <hgroup className="min-w-0">
              <h2 className="text-base font-bold text-fg-heading">{title}</h2>
              {description ? <p className="mt-0.5 text-sm text-fg-muted">{description}</p> : null}
            </hgroup>
          ) : (
            <span />
          )}
          {actions}
        </header>
      ) : null}
      <div className={bodyPadding}>{children}</div>
    </section>
  );
}
